import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { FrequencyClass } from "../core/type/Frequency";
import { optionsFromArguments } from "../core/util/Defaults";
import { noOp } from "../core/util/Interface";
import { Instrument } from "../instrument/Instrument";
import { timeRange } from "../core/util/Decorator";
/**
 * Abstract base class for other monophonic instruments to extend.
 */
export var Monophonic = /*#__PURE__*/function (_Instrument) {
  _inherits(Monophonic, _Instrument);
  function Monophonic() {
    var _this;
    _classCallCheck(this, Monophonic);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Monophonic).call(this, optionsFromArguments(Monophonic.getDefaults(), arguments)));
    var options = optionsFromArguments(Monophonic.getDefaults(), arguments);
    _this.portamento = options.portamento;
    _this.onsilence = options.onsilence;
    return _this;
  }
  _createClass(Monophonic, [{
    key: "triggerAttack",
    /**
     * Trigger the attack of the note optionally with a given velocity.
     * @param  note The note to trigger.
     * @param  time When the note should start.
     * @param  velocity The velocity scaler determines how "loud" the note will be triggered.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * // trigger the note a half second from now at half velocity
     * synth.triggerAttack("C4", "+0.5", 0.5);
     */
    value: function triggerAttack(note, time) {
      var velocity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      this.log("triggerAttack", note, time, velocity);
      var seconds = this.toSeconds(time);
      this._triggerEnvelopeAttack(seconds, velocity);
      this.setNote(note, seconds);
      return this;
    }
    /**
     * Trigger the release portion of the envelope
     * @param  time If no time is given, the release happens immediatly
     * @example
     * const synth = new Tone.Synth().toDestination();
     * synth.triggerAttack("C4");
     * // trigger the release a second from now
     * synth.triggerRelease("+1");
     */
  }, {
    key: "triggerRelease",
    value: function triggerRelease(time) {
      this.log("triggerRelease", time);
      var seconds = this.toSeconds(time);
      this._triggerEnvelopeRelease(seconds);
      return this;
    }
    /**
     * Set the note at the given time. If no time is given, the note
     * will set immediately.
     * @param note The note to change to.
     * @param  time The time when the note should be set.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * synth.triggerAttack("C4");
     * // change to F#6 in one quarter note from now.
     * synth.setNote("F#6", "+4n");
     */
  }, {
    key: "setNote",
    value: function setNote(note, time) {
      var computedTime = this.toSeconds(time);
      var computedFrequency = note instanceof FrequencyClass ? note.toFrequency() : note;
      if (this.portamento > 0 && this.getLevelAtTime(computedTime) > 0.05) {
        var portTime = this.toSeconds(this.portamento);
        this.frequency.exponentialRampTo(computedFrequency, portTime, computedTime);
      } else {
        this.frequency.setValueAtTime(computedFrequency, computedTime);
      }
      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Instrument.getDefaults(), {
        detune: 0,
        onsilence: noOp,
        portamento: 0
      });
    }
  }]);
  return Monophonic;
}(Instrument);
__decorate([timeRange(0)], Monophonic.prototype, "portamento", void 0);